const CollaborateDigitalDataSharing = () => {
  return "collaborate digital data sharing not implemented";
};
export default CollaborateDigitalDataSharing;
